import { MockedRequest, RequestHandler, rest, restContext } from 'msw';
import { User } from '@vis-auth/vis-user-client';
import {
  enrollmentUser,
  generalUser,
  generalUserNoTutorial,
  generalUserWithMyI9TrainingNotComplete,
  generalUserWithWebService,
} from '../fixtures/userTypes';

const users: Array<User> = [
  generalUser,
  generalUserWithWebService,
  generalUserNoTutorial,
  enrollmentUser,
  generalUserWithMyI9TrainingNotComplete,
];

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  rest.get('/api/visuser/users/:id', (req, res, ctx) => {
    const user = users.find((u) => u.id === req.params.id);

    if (user) {
      return res(ctx.json(user));
    }

    // id 999 is reserved for mocking error status of 401
    if (req.params.id === '999') {
      return res(
        ctx.status(401),
        ctx.json({ message: 'The client does not have valid authentication credentials for the target resource' }),
      );
    }
    return res(ctx.status(404), ctx.json({ message: 'User Not Found' }));
  }),
];

export default handlers;
